import { createElement, getSlideTransformEl } from './utils.js';
export default function createShadow(params, slideEl, side) {
  const shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : '');
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(".".concat(shadowClass));
  if (!shadowEl) {
    shadowEl = createElement('div', "swiper-slide-shadow".concat(side ? "-".concat(side) : ''));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}